module.exports = __webpack_public_path__ + "static/media/drums.8a144356.mid";